import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { findDOMNode } from 'react-dom';
import { connect, Dispatch } from 'react-redux';
import { MediaGalleryAppState } from '../../classes/index';
import { getMedia } from '../redux/actions/media-api';


function isElementVisible(el: Element, scroll?: boolean): boolean {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

interface LoaderExternalProps {

}

interface StateToProps {
    updating: boolean;
    noMoreMedia: boolean;
    mediaCount: number;
}

interface DispatchToProps {
    getNextBatch: () => any;
}

interface LoaderState {
}

type LoaderProps = LoaderExternalProps & StateToProps & DispatchToProps;

class MediaGalleryLoader extends React.Component<LoaderProps, LoaderState> {
    constructor(props: LoaderProps) {
        super(props);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.onBoundScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onBoundScroll);
    }

    componentWillReceiveProps(props: LoaderProps) {
        const element = findDOMNode(this) as Element;

        // Remove the scroll listener if there is no more media.
        if (props.noMoreMedia) {
            window.removeEventListener("scroll", this.onBoundScroll);
        }

        if (props.updating && props.noMoreMedia && isElementVisible(element)) {
            this.props.getNextBatch();
        }
    }

    private onBoundScroll = _.throttle(this.onScroll.bind(this), 500);

    private onScroll() {
        const element = findDOMNode(this) as Element;
        if (!this.props.updating && !this.props.noMoreMedia && isElementVisible(element)) {
            var interval = setInterval(() => {
                this.props.getNextBatch();
                if (this.props.mediaCount > 0) {
                    clearInterval(interval);
                }
            }, 500);          
        }
    }

    render() {
        return (
            <div className={`loader-container`} >
                {
                    this.props.noMoreMedia ? null : <div className="loader">Loading&hellip;</div>
                }
            </div>
        );
    }
}

function mapStateToProps(state: MediaGalleryAppState, externalProps: LoaderExternalProps): StateToProps {
    return {
        updating: state.mediaApiModel.requestingMedia,
        noMoreMedia: state.mediaApiModel.noMoreMedia,
        mediaCount: state.mediaApiModel.filteredMediaList.length
    }
}

function mapDispatchToProps(dispatch: Dispatch<MediaGalleryAppState>, externalProps: LoaderExternalProps): DispatchToProps {
    return {
        getNextBatch: () => dispatch(getMedia())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(MediaGalleryLoader);


// WEBPACK FOOTER //
// ./app/media-gallery/components/media-gallery-loader.tsx